/// <reference path="../../../../Scripts/typings/knockout.es5/knockout.es5.d.ts" />
define('areas/navigationmanager/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var NavigationVM = (function () {
        function NavigationVM() {
            ko.track(this);
        }
        return NavigationVM;
    }());
    exports.NavigationVM = NavigationVM;
    var NavigationNodeVM = (function () {
        function NavigationNodeVM() {
            this.groups = [];
            this.children = [];
            ko.track(this, ["type", "name", "template", "datakey", "index", "icon", "color", "useImage", "imagePath", "groupId", "shopId", "children", "defaultData", "groups", "imagePathSearchbar", "disableNavigateToFirstChild", "key", "showOnMobile", "openLinkInCurrentTab", "openInDialog", "permissionId"]);
        }
        NavigationNodeVM.prototype.getState = function () {
            var errors = new ErrorModel();
            if (!this.groupId)
                errors.addError("The 'groupId' is required.");
            return errors;
        };
        return NavigationNodeVM;
    }());
    exports.NavigationNodeVM = NavigationNodeVM;
    var NavigationGroupVM = (function () {
        function NavigationGroupVM() {
            ko.track(this, ["key", "title", "description", "index", "icon", "useImage", "imagePath", "showAddWidgets", "autoSelectIndex", "hideFromSidenav", "alwaysShowTiles", "showOnMobile"]);
        }
        NavigationGroupVM.createDefaultGroup = function () {
            var group = new NavigationGroupVM();
            group.title = "Default Group";
            group.key = "Default-Key";
            group.description = "Group Description...";
            group.index = -1;
            group.autoSelectIndex = -1;
            group.icon = "fa-youtube";
            group.useImage = false;
            group.imagePath = null;
            group.showAddWidgets = false;
            group.hideFromSidenav = false;
            group.alwaysShowTiles = false;
            group.showOnMobile = false;
            return group;
        };
        return NavigationGroupVM;
    }());
    exports.NavigationGroupVM = NavigationGroupVM;
    var ErrorModel = (function () {
        function ErrorModel() {
            this.errorMessages = [];
        }
        ErrorModel.prototype.getNumberOfErrors = function () {
            return this.errorMessages.length;
        };
        ErrorModel.prototype.isValid = function () {
            return this.errorMessages.length == 0;
        };
        ErrorModel.prototype.getErrors = function () {
            var result = "";
            this.errorMessages.forEach(function (msg) {
                result += msg;
            });
            return result;
        };
        ErrorModel.prototype.addError = function (messages) {
            messages = messages + "\n";
            this.errorMessages.push(messages);
        };
        ErrorModel.prototype.addErrors = function (messages) {
            var _this = this;
            messages.forEach(function (msg) {
                msg = msg + "\n";
                _this.errorMessages.push(msg);
            });
        };
        return ErrorModel;
    }());
    exports.ErrorModel = ErrorModel;
});

